import {
  Box,
  HStack,
  SimpleGrid,
  Skeleton,
  SkeletonText,
  Text,
} from "@chakra-ui/react";
import { PostsLandingInterface } from "../../constants/Landing";
import BlogCard from "../card/blog/BlogCard";

const TrendingBlogSection = ({
  blogData,
  isBlogDataLoading,
}: {
  blogData: PostsLandingInterface[] | undefined;
  isBlogDataLoading: boolean;
}) => {
  return (
    <Box>
      <Text textStyle={"h-title"}>Trending Blog</Text>

      <SimpleGrid
        w={"full"}
        columns={{ base: 1, md: 2, lg: 3 }}
        mt={"16px"}
        gap={"30px"}
      >
        {isBlogDataLoading
          ? Array.from({ length: 6 }).map((_, index) => (
              <HStack key={index} alignItems="center" gap={"12px"}>
                <Skeleton
                  w={{ base: "117px", xl: "142px" }}
                  h={{ base: "117px", xl: "142px" }}
                  rounded="12px"
                />
                <Box className=" w-[200px]" flex={1}>
                  <SkeletonText
                    noOfLines={2}
                    spacing="2"
                    skeletonHeight={"14px"}
                  />
                  <SkeletonText noOfLines={3} spacing="1" mt="12px" />
                  <SkeletonText
                    skeletonHeight="10px"
                    w="50%"
                    mt="20px"
                    noOfLines={1}
                  />
                </Box>
              </HStack>
            ))
          : blogData &&
            blogData.map((blog, index) => <BlogCard key={index} item={blog} />)}
      </SimpleGrid>
    </Box>
  );
};

export default TrendingBlogSection;
